import React, { Component, forwardRef } from 'react';
import PropTypes from 'prop-types';
import {
  Form,
} from 'semantic-ui-react';

import Validate from './Validate';

class TextArea extends Component {
  static propTypes = {
    placeholder: PropTypes.string,
    autoComplete: PropTypes.string,
    disabled: PropTypes.bool,
    hideMessage: PropTypes.bool,
    label: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.node,
    ]),
    loading: PropTypes.bool,
    rows: PropTypes.number,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    style: PropTypes.oneOfType([
      PropTypes.object,
    ]),
    validation: PropTypes.arrayOf(
      PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.shape({
          validate: PropTypes.func,
          option: PropTypes.object,
        }),
      ]).isRequired,
    ),
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    validateLabel: PropTypes.string,
    validateRef: PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.shape({}),
    ]),
  }
  render() {
    return (
      <Validate
        hideMessage={this.props.hideMessage}
        validation={this.props.validation}
        label={this.props.validateLabel || this.props.label}
        name={this.props.name}
        ref={this.props.validateRef}
        onChange={(e, data) => {
          // bubble up onChange
          if (this.props.onChange) {
            this.props.onChange(e, data);
          }
        }}
      >
        <Form.TextArea
          autoComplete={this.props.autoComplete}
          placeholder={this.props.placeholder}
          disabled={this.props.disabled}
          label={this.props.label}
          loading={this.props.loading}
          name={this.props.name}
          rows={this.props.rows}
          value={this.props.value}
          style={this.props.style && this.props.style}
        />
      </Validate>
    );
  }
}

export default forwardRef((props, ref) => <TextArea {...props} validateRef={ref} />);



// WEBPACK FOOTER //
// ./src/components/AppForm/TextArea.jsx